import script from "./ChatbotSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatbotSettings.vue?vue&type=script&setup=true&lang=js"

import "./ChatbotSettings.vue?vue&type=style&index=0&id=a0b2a9c6&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0b2a9c6"]])

export default __exports__